module.exports = __webpack_public_path__ + "static/media/export-file.29640752.png";